import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const Config = require('../../../config/default.env').default;

export default function AdsenseParallax({
  adSlot,
  style = {},
  adFormat = 'auto',
  adLayout = '',
  adLayoutKey = '',
}) {
  const adId = `adsense-parallax-${adSlot}-${Math.random()
    .toString(36)
    .substring(2, 11)}`;

  const width = '100%';
  const height = '100%';

  // Web-specific styles for DOM elements
  const getWebStyles = () => ({
    testContainer: {
      backgroundColor: '#f9f9f9',
      padding: 20,
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      boxSizing: 'border-box',
      width,
      height,
    },
    testContent: {
      color: '#666',
      fontSize: '14px',
      fontFamily: 'Arial, sans-serif',
    },
    adContainer: {
      display: 'block',
      width: '100%',
      height: '100%',
      maxWidth: '100%',
      maxHeight: '100%',
      boxSizing: 'border-box',
    },
  });

  const webStyles = getWebStyles();

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      window.adsbygoogle &&
      !Config.GOOGLE_ADSENSE_TEST_MODE
    ) {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.error('AdSense Parallax error:', e);
      }
    }
  }, []);

  if (!Config.GOOGLE_ADSENSE_ENABLED) {
    return null;
  }

  if (Config.GOOGLE_ADSENSE_TEST_MODE) {
    return (
      <div
        style={{
          ...webStyles.testContainer,
          ...style,
        }}>
        <div style={webStyles.testContent}>Advertisement</div>
      </div>
    );
  }

  const adProps = {
    key: adId,
    id: adId,
    className: 'adsbygoogle',
    style: {
      ...webStyles.adContainer,
      ...style,
    },
    'data-ad-client': Config.GOOGLE_ADSENSE_PUBLISHER_ID,
    'data-ad-slot': adSlot,
    'data-ad-format': adFormat,
  };

  if (adLayout) {
    adProps['data-ad-layout'] = adLayout;
  }
  if (adLayoutKey) {
    adProps['data-ad-layout-key'] = adLayoutKey;
  }

  return <ins {...adProps} />;
}

AdsenseParallax.propTypes = {
  adSlot: PropTypes.string.isRequired,
  style: PropTypes.object,
  adFormat: PropTypes.string,
  adLayout: PropTypes.string,
  adLayoutKey: PropTypes.string,
};
